import { Info } from "lucide-react";
import { AlertBar } from "@/components/AlertBar";
import { Fieldset } from "@/components/catalyst/Fieldset";
import { Heading } from "@/components/catalyst/Heading";
import { Text } from "@/components/catalyst/Text";
import { FinancesSection } from "../detail/components/FinancesSection";

/** Step 2: Set financial terms — payout rate, duration, redemptions, expiry. */
export function StepFinancialTerms() {
	return (
		<div>
			<Heading level={3}>Financial Terms</Heading>
			<Text className="mt-1 mb-6">
				Set the payout terms for this partner. These terms are permanently
				locked once the link is created.
			</Text>

			<AlertBar
				variant="default"
				title="Financial terms cannot be changed after creation."
				icon={Info}
			>
				To update terms, you'll need to delete this link and create a new one.
			</AlertBar>

			<Fieldset>
				<FinancesSection />
			</Fieldset>
		</div>
	);
}
